import openModal from 'App/services/Modal';
import RequestBuilder from 'Resources/RequestBuilder';
import type { VisitEntity } from 'App/helpers/visits/visitTargets';

/** Resolves once visits are booked, so the list reloads; a dismissal rejects and keeps the selection. */
export default function bookCustomerVisits(
	selection: RequestBuilder,
	list: RequestBuilder,
	entity: VisitEntity,
	count: number
): Promise<void> {
	return new Promise((resolve, reject) => {
		openModal('BookVisits', {
			entity,
			count,
			query: { q: selection.build().q, sort: list.build().sort },
			onClose: booked => (booked ? resolve() : reject())
		});
	});
}
